import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { PostCard, SkeletonCard } from "@/components/dm/PostCard";
import { EmptyState } from "@/components/dm/EmptyState";

export default function Saved() {
  const { t, user, ready, setAuth } = useApp();
  const [items, setItems] = useState(null);
  useEffect(() => { if (user) api.get("/saves").then((r) => setItems(r.data)); }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!ready) return null;
  if (!user) return <div className="max-w-xl mx-auto p-6"><EmptyState title={t("signup_prompt")}><button data-testid="saved-signup" onClick={() => setAuth({ mode: "prompt" })} className="press min-h-[52px] px-8 rounded-full bg-[#F59E0B] text-[#291E18] font-extrabold">{t("create_account")}</button></EmptyState></div>;
  return (
    <div className="max-w-6xl mx-auto px-4 py-6 space-y-5" data-testid="saved-page">
      <div className="space-y-1">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{t("saved_posts")}</h1>
        <p className="text-sm text-[#6B5E55]">{t("saved_alert_hint")}</p>
      </div>
      {items === null ? <div className="grid grid-cols-[minmax(0,1fr)] sm:grid-cols-2 lg:grid-cols-3 gap-5"><SkeletonCard /><SkeletonCard /></div>
        : items.length === 0 ? <EmptyState title={t("saved_none")} />
        : <div className="grid grid-cols-[minmax(0,1fr)] sm:grid-cols-2 lg:grid-cols-3 gap-5">{items.map((p) => <PostCard key={p.id} p={p} />)}</div>}
    </div>
  );
}
